(() => {
  function setup(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const viewport = root.querySelector('[data-marquee-viewport]');
    const track = root.querySelector('[data-marquee-track]');
    const original = root.querySelector('[data-marquee-original]');
    const toggle = root.querySelector('[data-marquee-toggle]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches, hovered = false, focused = false, visible = false;
    let frame = 0, last = 0, loopWidth = 0, position = 0, advancing = false, holdUntil = 0;
    // Senza pulsante di pausa, dopo un tocco o un clic sulle frecce lo scorrimento riprende da solo.
    const rest = () => { if (toggle) { paused = true; state(); } else holdUntil = performance.now() + Number(root.dataset.hold || 4000); };
    const clone = original.cloneNode(true);
    clone.removeAttribute('data-marquee-original');
    clone.setAttribute('data-marquee-copy', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('[id]').forEach(item => item.removeAttribute('id'));
    clone.querySelectorAll('[data-award-image]').forEach(item => item.removeAttribute('data-award-image'));
    clone.querySelectorAll('a, button').forEach(item => item.setAttribute('tabindex', '-1'));
    track.appendChild(clone);
    const state = () => {
      root.dataset.paused = String(paused);
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', String(paused));
      const label = paused ? 'Riprendi lo scorrimento' : 'Metti in pausa lo scorrimento';
      toggle.setAttribute('aria-label', label); toggle.title = label;
      root.dataset.paused = String(paused);
    };
    const tick = now => {
      const dt = Math.min((now - last) / 1000, .05); last = now;
      if (visible && !paused && !hovered && !focused && !document.hidden && loopWidth > 0 && now >= holdUntil) {
        if (!advancing) position = viewport.scrollLeft;
        position += dt * Number(root.dataset.speed || 24);
        if (position >= loopWidth) position -= loopWidth;
        viewport.scrollLeft = position;
        advancing = true;
      } else advancing = false;
      frame = requestAnimationFrame(tick);
    };
    const resize = new ResizeObserver(() => {
      loopWidth = original.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    });
    resize.observe(original);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      cancelAnimationFrame(frame);
      if (visible) { last = performance.now(); frame = requestAnimationFrame(tick); }
    });
    observer.observe(root);
    if (toggle) toggle.addEventListener('click', () => { paused = !paused; state(); });
    const step = direction => {
      rest();
      if (viewport.scrollLeft >= loopWidth) viewport.scrollLeft %= loopWidth;
      if (direction < 0 && viewport.scrollLeft < 1) viewport.scrollLeft = loopWidth;
      viewport.scrollBy({ left: direction * Math.max(260, viewport.clientWidth * .8), behavior: reduced.matches ? 'instant' : 'smooth' });
    };
    root.querySelector('[data-marquee-prev]').addEventListener('click', () => step(-1));
    root.querySelector('[data-marquee-next]').addEventListener('click', () => step(1));
    viewport.addEventListener('pointerenter', () => { hovered = true; });
    viewport.addEventListener('pointerleave', () => { hovered = false; });
    viewport.addEventListener('pointerdown', rest);
    viewport.addEventListener('touchmove', rest, { passive: true });
    viewport.addEventListener('wheel', rest, { passive: true });
    viewport.addEventListener('focusin', () => { focused = true; });
    viewport.addEventListener('focusout', event => { focused = viewport.contains(event.relatedTarget); });
    const motionChanged = event => { if (event.matches) { paused = true; state(); } };
    reduced.addEventListener('change', motionChanged);
    root.querySelector('[data-marquee-controls]').hidden = false;
    state();
    const dispose = () => { cancelAnimationFrame(frame); resize.disconnect(); observer.disconnect(); reduced.removeEventListener('change', motionChanged); };
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', dispose, { once: true });
    addEventListener('pagehide', event => { if (event.persisted) { paused = true; state(); } else dispose(); });
  }
  document.querySelectorAll('[data-evidence-marquee]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-evidence-marquee]').forEach(setup));
})();
